<!-- Template -->
<template>
  <section class="container-fluid p-0 bodyArea">
    <div class="justify-content-start">
      <div class="pageHeader row justify-content-between">
        <div>Gateway</div>
        <div>
          <div v-if="$auth.isAuthenticated" class="filterWrapper">
            <div class="filterText">Environment :</div>
            <Dropdown
                style="background: transparent; color: #fff; border: 0; height: auto"
                :options="environmentList"
                :disabled="false"
                v-on:selected="selectEnvironment"
                :maxItem="environmentList.length"
                name="environmentDropdown"
                placeholder="Please select an environment"
                class="dropdownList">
            </Dropdown>
          </div>
          <button id="submitBtn" class="filterWrapper submitBtn" @click="getGatewaysByEnvironment(); getTargetServersByEnvironment();">
            Submit
          </button>
        </div>
      </div>
    </div>

    <div v-if="loading" class="gateway__select-environment-message">
      <div class="d-flex justify-content-center align-items-center container mt-5">
        <div class="loader"></div>
      </div>
    </div>

    <div v-if="!viewReady && !loading" class="gateway__select-environment-message">
      <div class="d-flex justify-content-center align-items-center container mt-5">
        Select an environment.
      </div>
    </div>

    <div v-if="viewReady && !loading">
      <div class="overflow-auto gatewayViewWrapper">
        <ul class="nav nav-pills m-3" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <button @click="changeTab('Gateways')" v-bind:class="{ active: activeTab === 'Gateways' && gatewayList.length }" class="nav-link" id="pills-gateway-tab" data-bs-toggle="pill" data-bs-target="#pills-gateway-tab" type="button" role="tab" aria-controls="pills-gateway-tab" aria-selected="true">
              Gateways
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button @click="activeGateway = null; activeHref = null; changeTab('Gateways').then(() =>{ getTargetServersByEnvironment(); changeTab('Target Servers') });"  v-bind:class="{ active: activeTab === 'Target Servers' && targetServerList.length }" class="nav-link" id="pills-target-server-tab" data-bs-toggle="pill" data-bs-target="#pills-target-server-tab" type="button" role="tab" aria-controls="pills-target-server-tab" aria-selected="false">
              Target Servers
            </button>
          </li>
          <span class="ml-a"></span>
          <!-- <li v-if="activeTab === 'Target Servers'" class="nav-item" role="presentation">
            <button class="nav-link" id="pills-contact-tab">
              New Target (PLACEHOLDER TODO)
            </button>
          </li> -->
          <!-- <li v-if="activeTab === 'Gateways'" class="nav-item" role="presentation">
            <button class="nav-link" id="pills-contact-tab" disabled>
              New Gateway (PLACEHOLDER TODO)
            </button>
          </li> -->
          <li class="nav-item" role="presentation">
            <button v-if="activeTab !== 'Target Servers' && !activeHref && activeGateway" class="nav-link" id="pills-contact-tab" style="margin-right: 0;" @click="exportGatewayBundle(activeEnvironment, activeGateway, activeGateway.currentDeployment.revision)">
              Export Latest Deployment
            </button>
            <button v-if="activeTab !== 'Target Servers' && activeHref" @click="addEndpoint = !addEndpoint" class="nav-link" id="pills-contact-tab" style="margin-right: 0;">
              {{addEndpoint ? 'Cancel' : 'Add Endpoint'}}
            </button>
            <button v-if="activeTab !== 'Target Servers' && activeEnvironment && !activeGateway && !activeHref" @click="uploadGateway(activeEnvironment)" class="nav-link" id="pills-contact-tab" style="margin-right: 0;">
              Upload Gateway
            </button>
            <button v-if="activeTab === 'Target Servers'" class="nav-link" id="pills-contact-tab" style="margin-right: 0;" @click="addTargetServer = !addTargetServer;">
              {{addTargetServer ? 'Cancel' : 'Add Target Server'}}
            </button>
          </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
          <hr>
          <span class="gateway__bread-crumbs">
            <span>
              <!-- Back to root -->
              <span @click="activeGateway = null; activeHref = null; changeTab(activeTab)">
                /{{ activeTab }}/
              </span>

              <!-- Back to gateway root -->
              <span @click="activeHref = null; changeTab(activeTab).then(() => selectGateway(activeGateway))" v-if="activeGateway && !addTargetServer">
                {{ activeGateway ? activeGateway.id + '' : '' }}    
              </span>

              <!-- Back to gateway root -->
              <span v-if="activeHref || addTargetServer">
                {{ activeHref ? activeHref : addTargetServer ? "New Target Server" : "" }}    
              </span>
            </span>

            <!-- Back to root -->
            <span v-if="activeGateway && activeTab !== 'Target Servers'" @click="activeHref ? activeHref = null && changeTab(activeTab).then(() => selectGateway(activeGateway)) : activeGateway = null && changeTab(activeTab)">
              <img class="gateway__tool-button" style="height: 10px;" v-b-tooltip.hover title="Back to dashboard"
                      src="../../assets/images/back.svg" alt="back" />
            </span>  
          </span>
          <div v-if="activeTab === 'Gateways'" v-bind:class="{ show: activeTab === 'Gateways',  active: activeTab === 'Gateways' }" class="tab-pane fade" id="pills-gateway-tab" role="tabpanel" aria-labelledby="pills-gateway-tab">
            <div v-if="gatewayList.length > 0">
              <div class="table-responsive ">
                <b-table
                    v-if="!activeGateway"
                    id="gateway-table"
                    striped
                    hover
                    :items="gatewayList"
                    :sort-desc="true"
                    :fields="gatewayTableFields"
                    @row-clicked="selectGateway"
                    class="table table-hover m-0 align-middle"
                    medium>
                  <template #cell(currentDeployment.deploymentTimestamp)="data">
                    {{data.value ? (new Date(data.value)).toLocaleString() : " "}}
                  </template>
                  <template #cell(created)="data">
                    {{data.value ? (new Date(data.value)).toLocaleString() : " "}}
                  </template>
                  <template #cell(modified)="data">
                    {{data.value ? (new Date(data.value)).toLocaleString() : " "}}
                  </template> 
                  <template #cell(tools)="data">
                    <span style="display: flex; min-height: 21px; justify-content: flex-end; align-items: center;">
                      <img v-if="(!data.item.isLatestDeployed)" class="gateway__tool-button" @click.stop="deployGateway(activeEnvironment, data.item, data.item.currentRevision.revision)" v-b-tooltip.hover :title="data.item.currentDeployment.deployentState === 'ERROR' ? 'Redeploy' : 'Deploy'"
                      src="../../assets/images/deploy.svg" alt="deploy" />
                      <img v-if="(data.item.currentDeployment.deployentState)" class="gateway__tool-button" @click.stop="exportGatewayBundle(activeEnvironment, data.item, data.item.currentDeployment.revision)" v-b-tooltip.hover :title="'Export Current Deployment'"
                      src="../../assets/images/saveIcon.svg" alt="deploy" />
                      <img v-if="data.item.currentDeployment.deployentState === 'PROGRESSING'" class="gateway__tool-button" @click.stop="getGatewaysByEnvironment(); getTargetServersByEnvironment();" v-b-tooltip.hover :title="'Deployment PROGRESSING: Refresh API List'"
                      src="../../assets/images/refresh.svg" alt="refresh" />
                      <span 
                        class="gateway__deployment-state" :class="{'gateway__deployment-state--ready': data.item.currentDeployment.deployentState === 'READY' && data.item.isLatestDeployed, 'gateway__deployment-state--error': data.item.currentDeployment.deployentState === 'ERROR', 'gateway__deployment-state--progressing': data.item.currentDeployment.deployentState === 'PROGRESSING'}"
                        v-b-tooltip.hover :title="`${data.item.currentDeployment.deployentState ? data.item.currentDeployment.deployentState : 'READY'} - ${data.item.isLatestDeployed ? 'Latest Revision Deployed' : 'Latest Revision Not Deployed'}`"></span>
                    </span>
                  </template> 
                </b-table>
                <div v-if="activeGateway">
                  <gateway-table :data="{...activeGateway}" :activeEnvironment="{...activeEnvironment}" :activeHref="activeHref" :addEndpoint="addEndpoint" :targetServers="targetServerList" @refresh-gateway="getGatewaysByEnvironment();" @selected-href="focusBaseHref"></gateway-table>
                </div>
              </div>
            </div>
          </div>
          <div v-if="activeTab === 'Target Servers'" v-bind:class="{ show: activeTab === 'Target Servers',  active: activeTab === 'Target Servers' }" class="tab-pane fade" id="pills-target-server-tab" role="tabpanel" aria-labelledby="pills-target-server-tab">
            <div class="table-responsive ">
              <gateway-target-servers :data="targetServerList" :addTargetServer="addTargetServer" :environment="activeEnvironment" @refresh-targets="addTargetServer = false; getTargetServersByEnvironment()"></gateway-target-servers>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<!-- End Template -->

<!-- Scripts -->
<script>
import Vue from 'vue';
import { ref } from 'vue'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Dropdown from 'vue-simple-search-dropdown';
import GatewayTargetServers from "./GatewayTargetServers.vue";
import GatewayTable from "./GatewayTable.vue";
Vue.use(VueToast);
Vue.use(Loading);
Vue.component('gateway-table', GatewayTable);
Vue.component('gateway-target-servers', GatewayTargetServers);

export default {
  name: 'Gateway',
  components: { Dropdown, GatewayTable },
  data() {
    return {
      // View State & Init
      loading: true,
      viewReady: false,
      environmentList: [],
      activeEnvironment: null,

      // Active Environment Stage
      activeTab: "Gateways",
      gatewayList: [],
      targetServerList: [],
      activeGateway: null,
      activeHref: null,
      targetServerActive: null,

      // Actions
      addTargetServer: false,
      addEndpoint: false,

      // Pagination
      currentPage: 1,
      perPage: 100,
      totalSessions: 0,
      offset: 0,

      // Gateway Table Fields
      gatewayTableFields: [
        {
          key: 'id',
          label: 'Gateway Id',
          sortable: true,
        },
        {
          key: 'currentRevision.revision',
          label: 'Latest Revision',
          sortable: true,
        },
        {
          key: 'currentDeployment.deploymentTimestamp',
          label: 'Deployment Date',
          sortable: true,
        },
        {
          key: 'created',
          label: 'Creation',
        },
        {
          key: 'modified',
          label: 'Last Modified',
        },
        {
          key: 'tools',
          label: '',
        }
      ],

    };
  },

  async created() {
    setTimeout(
      function () {
        this.onInit();
      }.bind(this),
      1000
    );
  },

  methods: {
    async onInit() {
      if (!this.$auth.isAuthenticated) {
        return;
      }
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var environment_request = new Request(
        config.OPERATIONS_SERVICE + '/environments', 
        {
          method: 'GET',
          mode: 'cors',
          cache: 'default',
          withCredentials: true,
          credentials: 'include',
          headers: {
            Authorization: 'Bearer ' + id_token,
            'Content-Type': 'application/json',
          },
        }
      );

      // Attempt to get Gateways
      try {
        const environmentRequestResponse = await fetch(environment_request);
        if (environmentRequestResponse.status === 403) {
          Vue.$toast.open({
            message: "Uh oh... You don't have the permission required to access this resource",
            type: 'error',
          });
          return;
        }
        if (environmentRequestResponse.status == 401) {
          Vue.$toast.open({
            message: 'Your session has expired please login again to continue',
            type: 'error',
          });
          return;
        }
        if (environmentRequestResponse.status == 503) {
          return this.onInit();
        }
        if (environmentRequestResponse.status != 200) {
          Vue.$toast.open({
            message: 'Unable to get data',
            type: 'error',
          });
          return;
        } else {
          // Page can be interacted with
          this.loading = false;

          // Gateway List Processing
          const environmentList = await environmentRequestResponse.json();
          this.environmentList = Array.isArray(environmentList) ? environmentList : [];
        }
      } catch (tex) {
        Vue.$toast.open({message: 'Failed to get gateway list due to an error.', type: 'error'});
      }
    },

    selectEnvironment(env) { 
      // Find Environment
      if (env.id) {
        // Set Environment
        this.activeEnvironment = this.environmentList.find((findItem) => findItem.id = env.id); 
      }
    },

    async getGatewaysByEnvironment() {
      if (this.activeEnvironment) {
        // Component State Adjustments
        this.resetState();
        this.viewReady = false;
        this.loading = true;

        if (!this.$auth.isAuthenticated) {
          return;
        }
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var request = new Request(
          config.OPERATIONS_SERVICE + `/environments/${this.activeEnvironment.id}/apis`, 
          {
            method: 'GET',
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            headers: {
              Authorization: 'Bearer ' + id_token,
              'Content-Type': 'application/json',
            },
          }
        );

        // Attempt to get Gateways
        try {
          const response = await fetch(request);
          if (response.status === 403) {
            Vue.$toast.open({
              message: "Uh oh... You don't have the permission required to access this resource",
              type: 'error',
            });
            return;
          }
          if (response.status == 401) {
            Vue.$toast.open({
              message: 'Your session has expired please login again to continue',
              type: 'error',
            });
            return;
          }
          if (response.status == 503) {
            return this.getGatewaysByEnvironment();
          }
          if (response.status != 200) {
            Vue.$toast.open({
              message: 'Unable to get data',
              type: 'error',
            });
            return;
          } else {
            // Component State Adjustments
            this.viewReady = true;
            this.loading = false;

            // Gateway List Processing
            const formatted = await response.json();
            this.gatewayList = Array.isArray(formatted) ? formatted : [];
          }
        } catch (tex) {
          Vue.$toast.open({message: 'Failed to get gateway list due to an error.', type: 'error'});
        }
      }
    },

    async getTargetServersByEnvironment() {
      if (this.activeEnvironment) {
        if (!this.$auth.isAuthenticated) {
          return;
        }
        this.targetServerList = [];

        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var request = new Request(
          config.OPERATIONS_SERVICE + `/environments/${this.activeEnvironment.id}/targetservers`, 
          {
            method: 'GET',
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            headers: {
              Authorization: 'Bearer ' + id_token,
              'Content-Type': 'application/json',
            },
          }
        );

        // Attempt to get Gateways
        try {
          const response = await fetch(request);
          if (response.status === 403) {
            Vue.$toast.open({
              message: "Uh oh... You don't have the permission required to access this resource",
              type: 'error',
            });
            return;
          }
          if (response.status == 401) {
            Vue.$toast.open({
              message: 'Your session has expired please login again to continue',
              type: 'error',
            });
            return;
          }
          if (response.status == 503) {
            return this.getTargetServersByEnvironment();
          }
          if (response.status != 200) {
            Vue.$toast.open({
              message: 'Unable to get data',
              type: 'error',
            });
            return;
          } else {
            // Gateway List Processing
            let formatted = await response.json();

            formatted = formatted.sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              }
            });
            this.targetServerList = ((Array.isArray(formatted) ? formatted : []).map((item) => {
              item.editing = ref(false);
              return item;
            }));
          }
        } catch (tex) {
          Vue.$toast.open({message: 'Failed to get target server list due to an error.', type: 'error'});
        }
      }
    },

    async changeTab(tab) {
      if (tab) {
        this.addTargetServer = false;
        this.activeEnvironment = { ...this.activeEnvironment  };

        // Change tab
        this.activeTab = tab;
      }
    },

    focusBaseHref() {
      this.$set(this, 'addEndpoint', false);
      this.$set(this, 'activeHref', `/Routes`);
    },

    selectGateway(val) {
      this.$set(this, 'activeGateway', val);
    },

    generateTipData(id, type, options = null) {
      if (type && type.toLowerCase() === 'select') {
        return `
          <select>
            ${options.map((val) => `<option id="${val}" name="${val}">${val}</option>`)}
          </select>
          `
      } else if (type && type.toLowerCase() === 'input') {
        return '<input>';
      }
    },

    editProperty(target, data, property) {
      const element = document.getElementById(property);
      if (element) {
        element.disabled = false;
        const event = new MouseEvent('dblclick');
        element.dispatchEvent(event);
        element.dispatchEvent(event);
      }
    },

    async exportGatewayBundle(environment, gateway, revision) {
      if (environment && gateway && revision) {
        if (!this.$auth.isAuthenticated) {
          return;
        }
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var request = new Request(
          config.OPERATIONS_SERVICE + `/environments/${environment.id}/gateways/${gateway.id}/revisions/${revision}/export`, 
          {
            method: 'GET',
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            headers: {
              Authorization: 'Bearer ' + id_token
            },
          }
        );

        // Attempt to get Gateways
        try {
          const response = await fetch(request);
          if (response.status === 403) {
            Vue.$toast.open({
              message: "Uh oh... You don't have the permission required to access this resource",
              type: 'error',
            });
            return;
          }
          if (response.status == 401) {
            Vue.$toast.open({
              message: 'Your session has expired please login again to continue',
              type: 'error',
            });
            return;
          }
          if (response.status == 503) {
            return this.exportGatewayBundle(environment, gateway, revision);
          }
          if (response.status != 200) {
            Vue.$toast.open({
              message: 'Unable to get data',
              type: 'error',
            });
            return;
          } else {
            // Finish Download
            const file = await response.blob();
            this.download(file, `${gateway.id}__Rev${revision}__${(new Date(gateway.modified)).toISOString()}.zip`)
          }
        } catch (tex) {
          Vue.$toast.open({message: 'Failed to get bundle due to an error.', type: 'error'});
        }
      }
    },

    async uploadGateway(environment) {
      Vue.$toast.open({message: 'Select your Gateway Bundle.', type: 'info'});
      const input = document.createElement('input');
        input.type = 'file';
        input.click();
        input.setAttribute('accept', '.zip')
        input.addEventListener(
          'change',
          async () => { 
            const file = input.files[0];
            if (file && file.name.endsWith('.zip')) {
              const bundle = new Blob([file], {"type": "application/zip"});
              const formdata = new FormData();
              formdata.append("bundle", bundle);
              
              if (!this.$auth.isAuthenticated) {
                return;
              }
              const claims = await this.$auth.getIdTokenClaims();
              const id_token = claims.__raw;
              var request = new Request(
                config.OPERATIONS_SERVICE + `/environments/${environment.id}/gateways`, 
                {
                  method: 'POST',
                  mode: 'cors',
                  cache: 'default',
                  withCredentials: true,
                  credentials: 'include',
                  headers: {
                    Authorization: 'Bearer ' + id_token,
                    "Content-Type": 'application/json'
                  },
                  body: JSON.stringify({
                    name: file.name.split('.zip')[0],
                    bundle: await this.getBase64(bundle)
                  }),
                }
              );

              // Attempt to get Gateways
              try {
                const response = await fetch(request);
                if (response.status === 403) {
                  Vue.$toast.open({
                    message: "Uh oh... You don't have the permission required to access this resource",
                    type: 'error',
                  });
                  return;
                }
                if (response.status == 401) {
                  Vue.$toast.open({
                    message: 'Your session has expired please login again to continue',
                    type: 'error',
                  });
                  return;
                }
                if (response.status == 503) {
                  return this.uploadGateway(environment);
                }
                if (response.status != 200) {
                  Vue.$toast.open({
                    message: 'Unable to get data',
                    type: 'error',
                  });
                  return;
                } else {
                  const json = await response.json();
                  if (json.name) {
                    this.getGatewaysByEnvironment(); 
                    Vue.$toast.open({message: `Uploaded Gateway ${json.name} Revision ${json.revision}.`, type: 'info'});
                  }
                }
              } catch (tex) {
                Vue.$toast.open({message: 'Failed to upload bundle due to an error.', type: 'error'});
              }
            }
          },
          false
        );
    },

    async deployGateway(environment, gateway, revision) {
      if (environment && gateway && revision) {
        if (!this.$auth.isAuthenticated) {
          return;
        }
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var request = new Request(
          config.OPERATIONS_SERVICE + `/environments/${environment.id}/gateways/${gateway.id}/revisions/${revision}/deploy`, 
          {
            method: 'POST',
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            headers: {
              Authorization: 'Bearer ' + id_token
            },
          }
        );

        // Attempt to get Gateways
        try {
          const response = await fetch(request);
          if (response.status === 403) {
            Vue.$toast.open({
              message: "Uh oh... You don't have the permission required to access this resource",
              type: 'error',
            });
            return;
          }
          if (response.status == 401) {
            Vue.$toast.open({
              message: 'Your session has expired please login again to continue',
              type: 'error',
            });
            return;
          }
          if (response.status == 503) {
            return this.exportGatewayBundle(environment, gateway, revision);
          }
          if (response.status != 200) {
            Vue.$toast.open({
              message: 'Unable to get data',
              type: 'error',
            });
            return;
          } else {
            const json = await response.json();
            if (json.message == "Duplicate") {
              Vue.$toast.open({message: 'Failed to deploy bundle due to it already being deployed.', type: 'info'});
              return;
            } else {
              this.getGatewaysByEnvironment(); this.getTargetServersByEnvironment();
              Vue.$toast.open({message: `Deployed Gateway ${gateway.id} Revision ${revision}.`, type: 'info'});
            }
          }
        } catch (tex) {
          Vue.$toast.open({message: 'Failed to deploy bundle due to an error.', type: 'error'});
        }
      }
    },
    
    closeTooltips() {
      this.$root.$emit('bv::hide::tooltip');
    },

    async getBase64(file) {
      return new Promise((resolve) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
        };
      })
    },
    
    resetState() {
      this.$set(this, 'activeGateway', null);
      this.$set(this, 'activeHref', null);
    },

    download(blob, fileName) {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(
        blob,
      );
      a.download = fileName;
      a.click();
    },
  },

  computed: {

  },
  
  watch: {
    async currentPage() {

    },
  },
};
</script>
<!-- End Scripts -->

<!-- Styles -->
<style lang="scss" scoped>
  .nav-link {
    -webkit-transition: 150ms -webkit-filter linear;
    -moz-transition: 150ms -moz-filter linear;
    -moz-transition: 150ms filter linear;
    -ms-transition: 150ms -ms-filter linear;
    -o-transition: 150ms -o-filter linear;
    transition: 150ms all linear, 150ms -webkit-all linear;

    &:hover {
      filter: brightness(106%);
    }
  }

  .gateway__deployment-state {
    display: block;
    cursor: pointer;
    height: 10px;
    width: 10px;
    margin-left: 10px;
    border-radius: 50%;
    background-color: #6a6a6a;
  }

  .gateway__deployment-state--error {
    background-color: #F27778;
  }

  .gateway__deployment-state--ready {
    background-color: #66BE6D;
  }

  .gateway__deployment-state--progressing {
    background-color: #46b6c5;
  }

  .gateway__bread-crumbs {
    padding: 0 15px;
    color: rgba(37,168,202,1);
    transition: color 150ms;
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;

    span {
      cursor: pointer;

      span {
        &:hover {
          color: #64dfdf;
        }
      }
    }
  }

  .gateway__select-environment-message {
    width: 250px;
    position: fixed;
    top: 50%;
    left: calc(50% - 125px);
  }

  .gateway__tool-button {
    height: 15px;
    cursor: pointer;
    filter: invert(46%) sepia(75%) saturate(477%) hue-rotate(145deg) brightness(106%) contrast(87%);
    margin-left: 10px;
  }

  .gateway__tool-button:hover {
    filter: invert(46%) sepia(75%) saturate(477%) hue-rotate(145deg) brightness(120%) contrast(87%);
  }
</style>

<style lang="scss">
body .dropdown .dropdown-input {
  border: none !important;
  padding: 0 15px !important;
  background: none !important;
  font-size: 16px !important;
}

body .dropdown.dropdownList .dropdown-input {
  color: #fff !important;
  border: none !important;
  padding: 0 15px !important;
  background: none !important;
  font-size: 14px !important;
}

body .dropdown .dropdown-input:focus,
body .dropdown .dropdown-input:focus-visible {
  outline: none;
}

.dropdownList input::-webkit-input-placeholder {
  color: #fff !important;
}

::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #a6e3f0 !important;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  background: #f2fdff !important;
}
.pageHeader .filterText{
  padding-right: 0px !important;
}
.pageHeader .filterText.pad-10{
  padding-right: 10px !important;
}
</style>

<style lang="scss" scoped>
@font-face {
  font-family: GTWalsheimPro-Regular;
  src: url(../../assets/fonts/GTWalsheimPro-Regular.eot);
  src: url(../../assets/fonts/GTWalsheimPro-Regular.eot) format('embedded-opentype'),
  url(../../assets/fonts/GTWalsheimPro-Regular.ttf) format('truetype'),
  url(../../assets/fonts/GTWalsheimPro-Regular.svg) format('svg');
  font-weight: normal;
  font-style: normal;
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body,
html {
  font-family: GTWalsheimPro-Regular !important;
  background: #fff !important;
  font-size: 16px;
  overflow-x: hidden;
}

b,
strong {
  font-weight: 500;
}

button,
html input[type='button'],
input[type='reset'],
input[type='submit'] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
  outline: 0 !important;
}

a,
a img,
a:active,
a:focus,
button:focus,
a:hover {
  outline: 0 !important;
  -webkit-transition: all 0.35s;
  -moz-transition: all 0.35s;
  transition: all 0.35s;
  text-decoration: none;
  cursor: pointer;
  color: #5ed1d1;
}

a:hover {
  text-decoration: underline;
}

img {
  border: 0 !important;
}

a:focus:not(:hover),
button:focus:not(:hover) {
  outline: 0;
}

.table-responsive {
  margin-bottom: 0px;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(4, 78, 89, 1) !important;
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(4, 78, 89, 1) !important;
}

::-moz-selection {
  /* Code for Firefox */
  color: #fbeeef;
  background: #202533;
}

::selection {
  color: #fbeeef;
  background: #202533;
}

/* Scroll Bar Styling */

/* width */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f2fdff;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Checkbox CSS ends here */
.bodyArea {
  font-family: GTWalsheimPro-Regular;
}

.pageHeader {
  height: 70px;
  color: #fff;
  background: rgba(37, 168, 202, 0.8);
  font-size: 22px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
}

.filterWrapper {
  background: #25a8ca;
  display: inline-flex;
  padding: 5px 15px;
  font-size: 16px;
  min-width: 350px;
  border-radius: 5px;
  margin-left: 15px;
  line-height: 40px;
  text-overflow: ellipsis;
}

.subFilterWrapper {
  background: rgb(99, 101, 101);
  display: inline-flex;
  padding: 5px;
  font-size: 16px;
  min-width: 250px;
  border-radius: 5px;
  margin-left: 15px;
  //max-width: 250px;
  line-height: 40px;
  text-overflow: ellipsis;
}

.filterWrapper.submitBtn {
  max-width: none !important;
  min-width: 0 !important;
  border: none;
  color: #fff;
}

.filterText {
  color: #fff;
  opacity: 1;
  padding-right: 20px;
  white-space: nowrap;
}

.filterWrapper .dropdown {
  cursor: pointer;
  background: transparent !important;
  position: relative;
}

.filterWrapper .dropdown:before {
  content: '';
  border: solid #fff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2.5px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 10px;
  top: 15px;
}

.filterWrapper.exportBtn {
  max-width: none !important;
  min-width: 0 !important;
  border: none;
  color: #fff;
}

.filterWrapper select {
  width: 100%;
  text-align: left;
  border: none;
}

.filterWrapper select.active {
  color: #fff;
}

.gatewayViewWrapper {
  font-size: 14px;
  width: 97%;
  overflow: auto;
  border-radius: 10px;
  border: 1px solid lightgray;
  margin: 20px;
}

body select {
  width: 100px !important;
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
}

body select option {
  width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #7a8991;
}

body select[data-v-33144d13] {
  width: 200px !important;
  overflow: hidden !important;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.loader {
  border: 3px solid #f3f3f3; /* Light grey */
  border-top: 3px solid rgba(37, 168, 202, 0.8); /* Blue */
  border-radius: 50%;
  width: 45px;
  height: 45px;
  animation: spin 1.5s linear infinite;
}

.ml-a {
  margin-left: auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
<!-- End Styles -->